export enum Role {
    COMPANY = 'COMPANY',
    EMPLOYEE = 'EMPLOYEE',
    FREELANCE = 'FREELANCE'
}   

export type Roles = Role.COMPANY | Role.EMPLOYEE | Role.FREELANCE;

export const RolesArray = ['COMPANY', 'EMPLOYEE', 'FREELANCE'];